import {SET_COMPANY_INTEGRATION} from "../actions/types";

export default (state = {}, action) => {
	switch(action.type) {
        case SET_COMPANY_INTEGRATION:
			return {...state, activeCompanyIntegrations: action.payload  != undefined  ? action.payload : {}}
		default:
            return state;
	}
}